




































import mixins from 'vue-typed-mixins'
import {
  LocationType,
  LocationGps,
} from '@/interfaces/valuation/types/LocalityValuationStep'
import localityPicker from '@/mixins/valuation/localityPicker'
import { getNestedValue } from '@/util/helpers'
import { ValidatedResponse } from '@/interfaces/app/ValueObjects'

export default mixins(localityPicker).extend({
  name: `${LocationType.GPS}-picker`,
  created() {
    if (getNestedValue(this.locationData, ['locationLat'], false)) {
      this.locationLat = this.locationData!.locationLat
    }
    if (getNestedValue(this.locationData, ['locationLng'], false)) {
      this.locationLng = this.locationData!.locationLng
    }
  },
  data(): {
    locationLat: string
    locationLng: string
  } {
    return {
      locationLat: '',
      locationLng: '',
    }
  },
  computed: {
    locationData(): LocationGps | undefined {
      const stepData = this.$store.getters['valuationProcess/currentStepData']
      if (stepData.location) {
        return stepData.location as LocationGps
      }
    },
    location(): ValidatedResponse<LocationGps> {
      if (!this.locationLat || !this.locationLng) {
        return { valid: false }
      }

      return {
        valid: true,
        value: {
          locationLat: this.locationLat,
          locationLng: this.locationLng,
        },
      }
    },
  },
})
